import React from "react";
import { Grid, MenuItem, Paper } from "@mui/material";
import { FormInput } from "../../../../components/input/FormInput";
import * as yup from "yup";
import { useFormik } from "formik";
import { validations } from "./validations";
import { makeStyles } from "@mui/styles";
import { getCodigoUsuario } from "../../../../utils/Common";
import Api from "../../../../utils/services/Api";
import EndPoints from "../../../../utils/services/EndPoints";
import { useEdicionSocio } from "../../../../context/socio/use-edicion-socio";
import { LoadingButton } from "@mui/lab";
import AddIcon from '@mui/icons-material/Add';
import { useSnackbar } from "notistack";

const useStyles = makeStyles((theme) => ({
  paperContainer: {
    padding: 16
  }
}));

const operadoras = [
  {
    value: 1,
    label: "Claro"
  },
  {
    value: 2,
    label: "Movistar"
  }
];

const tiposTelefono = [
  {
    value: 1,
    label: "Convencional"
  },
  {
    value: 2,
    label: "Celular"
  }
];

const AgregarContactoSection = ({
  onSubmitted,
}) => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const {
    infoSocio: {
      datosBasicosMs: {
        codigoPersona
      }
    },
  } = useEdicionSocio()
  const {
    handleSubmit,
    handleChange,
    handleBlur,
    values,
    touched,
    errors,
    isSubmitting,
  } = useFormik({
    initialValues: {
      idTipoTelefono: "",
      idOperadora: "",
      numero: "",
    },
    validationSchema: yup.object().shape(validations),
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      try {
        const usuario = getCodigoUsuario();
        const body = {
          codigo: 0,
          codigoUsuarioActualiza: usuario,
          codigoUsuarioRegistra: usuario,
          tipoTelefono: values.idTipoTelefono,
          fechaActualiza: new Date(),
          fechaRegistro: new Date(),
          operadora: values.idOperadora,
          numero: values.numero,
          personaMs: {
            codigo: codigoPersona
          },
        };
        await Api(EndPoints.addTelefono, "POST", body)
        enqueueSnackbar("Agregado correctamente", { variant: "success" })
        resetForm()
        onSubmitted()
      } catch (error) {
        enqueueSnackbar(error.message, { variant: "error" })
      } finally {
        setSubmitting(false)
      }
    },
  });

  return (
    <Paper
      variant="outlined"
      classes={{
        root: classes.paperContainer
      }}
    >
      <Grid container spacing={2} component="form" onSubmit={handleSubmit}>
        <Grid item xs={12} md={4}>
          <FormInput
            formName="idTipoTelefono"
            label="Tipo telefono "
            value={values.idTipoTelefono}
            onChange={handleChange("idTipoTelefono")}
            onBlur={handleBlur}
            touched={touched}
            errors={errors}
            select
            disabled={isSubmitting}
          >
            {tiposTelefono.map(option => (
              <MenuItem
                key={option.value}
                value={option.value}
              >
                {option.label}
              </MenuItem>
            ))}
          </FormInput>
        </Grid>
        <Grid item xs={12} md={4}>
          <FormInput
            formName="idOperadora"
            label="Operadora"
            value={values.idOperadora}
            onChange={handleChange("idOperadora")}
            onBlur={handleBlur}
            touched={touched}
            errors={errors}
            select
            disabled={isSubmitting}
          >
            {operadoras.map(option => (
              <MenuItem
                key={option.value}
                value={option.value}
              >
                {option.label}
              </MenuItem>
            ))}
          </FormInput>
        </Grid>
        <Grid item xs={12} md={4}>
          <FormInput
            formName="numero"
            label="Número"
            value={values.numero}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched}
            errors={errors}
            disabled={isSubmitting}
          />
        </Grid>
        <Grid item xs={12} sx={{ textAlign: "center" }}>
          <LoadingButton
            type="submit"
            variant="outlined"
            color="primary"
            loading={isSubmitting}
            startIcon={
              <AddIcon />
            }
            loadingPosition="start"
          >
            <span>Agregar</span>
          </LoadingButton>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default AgregarContactoSection;
